<template>
  <div class="result">
    <notes-sidebar />
    <Table
      v-if="results.headers"
      :headers="headers"
      :actions="actions"
      id="custom-table-for-width"
      :class="{'dynamic-width': customTableWidth < 1114 }"
      hideDefaultFooter>
      <template v-slot:body>
        <template v-for="group in items">
          <tr
            :key="group.id"
            class="row-group"
            @click="toggleRowGroup(group.name)"
            :class="{
              'expand-row-group': expandedRowsGroup.includes(group.name),
            }"
          >
            <td class="totalTableSupWidth">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center" style="column-gap: 8px">
                  <img :src="getImgWithExt(['icons', group.name === 'Survey' ? 'result-group-survey' : group.name === 'Blood' ? 'result-group-blood' : 'result-group-default', 'svg'])" alt="icon" />
                  <Img :src="getImgWithExt(['icons', 'chevron-up-grey', 'svg'])"
                       :class="{ 'rotate-180': !expandedRowsGroup.includes(group.name) }"/>
                  <span class="group-values group-values__title">{{group.name}} {{getSelectedItems(group.resultSupplements.$values)}} ({{group.count}})</span>
                </div>
              </div>
            </td>
            <td class="pa-0 dosageUponArisingWidth">
              <div class="d-flex align-center justify-center">
                <span class="group-values">{{group.totalDosageUponArising}}</span>
              </div>
            </td>
            <td class="pa-0 dosageBreakfastWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosageBreakfast}}
              </div>
            </td>
            <td class="pa-0 dosage10amWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosage10am}}
              </div>
            </td>
            <td class="pa-0 dosageLunchWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosageLunch}}
              </div>
            </td>
            <td class="pa-0 dosage3pmWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosage3pm}}
              </div>
            </td>
            <td class="pa-0 dosageDinnerWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosageDinner}}
              </div>
            </td>
            <td class="pa-0 dosage7pmWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosage7pm}}
              </div>
            </td>
            <td class="pa-0 dosageBeforeSleepWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalDosageBeforeSleep}}
              </div>
            </td>
            <td class="pa-0 daysPerWeekWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.daysPerWeek}}
              </div>
            </td>
            <td class="patientNotesWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.patientNotes}}
              </div>
            </td>
            <td class="totalScoreWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.averageScore}}
              </div>
            </td>
            <td class="daysSupplyWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.daysSupply}}
              </div>
            </td>
            <td class="bottlesWidth">
              <div class="d-flex align-center justify-center group-values">
                {{group.totalBottles}}
              </div>
            </td>
            <td class="totalCostWidth">
              <div class="d-flex align-center justify-center group-values">
                ${{group.totalPrice}}
              </div>
            </td>
            <td>
            </td>
          </tr>
          <template v-for="(item, index) in group.resultSupplements.$values">
            <tr
              :key="item.id"
              class="custom-result-table__dynamic"
              v-if="expandedRowsGroup.includes(item.sourceName)"
              :class="{
              'expand-row': expandedRows.includes(item.id),
              'is-manual-entered': item.manuallyEntered,
              'is-default': item.isDefault
            }"
            >
              <td ref="totalTableSupWidth" class="totalTableSupWidth" :class="{'red-line': item.sourceName === 'Blood', 'blue-line': item.sourceName === 'Survey'}">
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <Img @click="toggleRow(item.id)" class="rotate-180 mr-2" :src="getImgWithExt(['icons', 'chevron-up-grey', 'svg'])"/>
                    <checkbox :class="{'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)}" :color="item.isDuplicated ? '#F68E87' : '#008C89'" :inputValue="item.selected" @change="updateSupplementUse(item, $event)"></checkbox>
                    <span
                      class="supplement-width d-flex align-center cell-style"
                      :class="{'disabled': visit.status === 'Completed'}"
                      style="column-gap: 8px"
                      @click="editResult(item)">{{item.supplementName}}
                    <v-tooltip top :max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <Img
                          @click.stop="handleCrgNotesClick(item)"
                          :src="getImgWithExt(['icons', item.isDuplicated ? 'info-circle-red' : 'info-circle-grey', 'svg'])"
                          width="20"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <span>{{item.supplementDescription}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.brandLogo">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" @click.stop style="width: 20px; height: 20px; background: transparent">
                          <Img class="d-flex" width="20" height="20" :src="item.brandLogo" />
                        </div>
                      </template>
                      <span>{{item.brandName}}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.vegetarian">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" style="width: 20px">
                          <Img class="d-flex" width="20" :src="getImgWithExt(['icons', 'vegan_icon', 'svg'])" />
                        </div>
                      </template>
                      <span>Vegetarian</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.glutenFree" >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" style="width: 20px">
                          <Img class="d-flex" width="20" :src="getImgWithExt(['icons', 'gluten_icon', 'svg'])" />
                        </div>
                      </template>
                      <span>Gluten Free</span>
                    </v-tooltip>
                    <v-tooltip top color="#F7936F" v-if="item.fromProtocol">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="mr-1" style="width: 20px">
                          <Img class="d-flex" width="20" :src="getImgWithExt(['icons', 'protocol_icon', 'svg'])" />
                        </div>
                      </template>
                      <span>{{item.protocolName}}</span>
                    </v-tooltip>
                    <v-tooltip top color="#28605A" v-if="item.fromBlood">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" style="width: 20px">
                          <Img class="d-flex" width="20" :src="getImgWithExt(['icons', 'blood_icon', 'svg'])" />
                        </div>
                      </template>
                      <span>Blood</span>
                    </v-tooltip>
                    <v-tooltip top color="#499D66" v-if="item.fromBloodPattern">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="circle-dot green" v-bind="attrs" v-on="on"></div>
                      </template>
                      <span>Blood Pattern</span>
                    </v-tooltip>
                    <v-tooltip top color="#F16063" v-if="item.fromBloodMarkerLab">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="circle-dot dark-orange" v-bind="attrs" v-on="on"></div>
                      </template>
                      <span>Blood Marker</span>
                    </v-tooltip>
                    <v-tooltip top color="#00E0FF" v-if="item.fromBloodMarkerOptimal">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="circle-dot light-blue" v-bind="attrs" v-on="on"></div>
                      </template>
                      <span>Blood Marker Optimal</span>
                    </v-tooltip>
                  </span>
                  </div>
                  <div class="d-flex align-center tooltips"></div>
                </div>
              </td>
              <td class="pa-0 dosageUponArisingWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="font-weight-bold">{{item.dosageUponArising ? item.dosageUponArising : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosageUponArising'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosageBreakfastWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosageBreakfast ? item.dosageBreakfast : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosageBreakfast'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosage10amWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosage10am ? item.dosage10am : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosage10am'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosageLunchWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosageLunch ? item.dosageLunch : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosageLunch'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosage3pmWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosage3pm ? item.dosage3pm : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosage3pm'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosageDinnerWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosageDinner ? item.dosageDinner : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosageDinner'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosage7pmWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosage7pm ? item.dosage7pm : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosage7pm'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 dosageBeforeSleepWidth">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.dosageBeforeSleep ? item.dosageBeforeSleep : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosages"
                    :itemRow="item"
                    :propertyKey="'dosageBeforeSleep'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="pa-0 daysPerWeekWidth" :style="item.customDayPerWeek ? 'background: #f9ffd1' : ''">
                <v-menu
                  :close-on-content-click="true"
                  offset-x
                  :disabled="['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)"
                  max-width="50px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex align-center justify-center width100 height100"
                         v-bind="attrs"
                         v-on="on">
                      <span class="cell-style">{{item.daysPerWeek ? item.daysPerWeek : ''}}</span>
                    </div>
                  </template>
                  <dosage-control
                    :dosages="supplementDosagesDaysPerWeek"
                    :itemRow="item"
                    :propertyKey="'daysPerWeek'"
                    @update="updateSupplementDosage"
                  />
                </v-menu>
              </td>
              <td class="patientNotesWidth" :style="item.patientNotes || item.patientNotesSpanish || item.clinicianNotes ? 'background: #f4f49b' : ''">
                <div class="d-flex align-center justify-center">
                  <v-tooltip top :max-width="400" v-if="item.specialNotes">
                    <template v-slot:activator="{ on, attrs }">
                      <Img @click="warningNotes(item)" v-bind="attrs" v-on="on" :src="getImgWithExt(['icons', 'alert-outline', 'svg'])" style="cursor: pointer" width="20"/>
                    </template>
                    <span>{{item.specialNotes}}</span>
                  </v-tooltip>
                </div>
              </td>
              <td class="totalScoreWidth">
                <div class="d-flex align-center justify-center">
                  <span class="cell-style">{{item.totalScore ? item.totalScore : ''}}</span>
                </div>
              </td>
              <td class="daysSupplyWidth">
                <div class="d-flex align-center justify-center">
                  <span class="cell-style">{{item.daysSupply ? item.daysSupply : ''}}</span>
                </div>
              </td>
              <td class="bottlesWidth">
                <div class="d-flex align-center justify-center">
                  <span class="cell-style">{{item.bottles ? item.bottles : ''}}</span>
                </div>
              </td>
              <td class="totalCostWidth">
                <div class="d-flex align-center justify-center">
                  <span class="cell-style">${{item.totalCost ? item.totalCost.toFixed(2) : ''}}</span>
                </div>
              </td>
              <td>
                <div class="d-flex align-center justify-center" :class="{ 'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status) }">
                  <actions :items="actions"
                           v-if="!visit.finishedOn || !['InProtocol', 'NeedProduct', 'Completed', 'ProtocolEnding'].includes(visit.status)"
                           @action="runAction"
                           :item="item"
                  />
                </div>
              </td>
            </tr>
            <td colspan="100%"
                class="product-supplement"
                :key="index + item.id"
                v-if="expandedRows.includes(item.id)">
              <v-card elevation="2">
                <Table hideDefaultFooter>
                  <template v-slot:body>
                    <tr :key="index + item.id" class="sub-row">
                      <th style="width: 60%; text-align: left; padding-left: 20px">
                        <span class="sub-row__title">Supplement Bottles and Prices</span>
                      </th>
                      <th style="width: 90px">
                        <span class="sub-row__title">Product</span>
                      </th>
                      <th style="width: 37px">
                        <span class="sub-row__title">Size</span>
                      </th>
                      <th style="width: 100px">
                        <span class="sub-row__title">Unit Price</span>
                      </th>
                      <th style="width: 49px">
                        <span class="sub-row__title">Q-TY</span>
                      </th>
                      <th style="padding: 0 5px;">
                        <span class="sub-row__title">Total Price</span>
                      </th>
                      <th></th>
                    </tr>
                    <tr :key="index" class="sub-row">
                      <td style="display: flex;flex-direction: column;border-bottom: unset;padding-top: 10px;">
                        <span class="font-weight-bold">{{item.supplementName}}</span>
                        <div class="product-bottles">
                          <div class="main-row">
                            <div class="bottle"
                                 v-for="bottle in item.supplementProducts.$values"
                                 :class="{
                                 'discontinued': bottle.discontinued,
                                 'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status)
                               }"
                                 :key="bottle.id"
                                 :id="`bottle-${bottle.id}`"
                                 @click="createNewSupplementProduct(item.id, bottle)"
                            >
                              <div style="width: 75%">
                                <div class="d-flex" style="justify-content: space-evenly">
                                  <div class="btn-bottle">
                                    <v-badge
                                      :color="bottle.discontinued ? '#A0AEC0' : '#008C89'"
                                      :content="getQuantityBySupplementProductId(item.resultProducts.$values, bottle.id)"
                                      overlap
                                    >
                                      <Img style="width: 30px" :class="{ 'discontinued': bottle.discontinued }" :src="getImgWithExt(['icons', 'bottle', 'svg'])" />
                                    </v-badge>
                                  </div>
                                  <div class="vitamins"></div>
                                  <div class="bottle-info" :class="{ 'discontinued': bottle.discontinued }">
                                    <p>{{bottle.productNumber}}</p>
                                    <p style="font-size: 17px">{{bottle.dosesPerBottle}}</p>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div class="bottle-cost" :class="{ 'discontinued': bottle.discontinued }">
                                    <span>${{bottle.listPrice}} SLP</span>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div class="bottle-plus" :class="{ 'discontinued': bottle.discontinued }">
                                  <v-icon>mdi-plus</v-icon>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td colspan="6">
                        <Table hideDefaultFooter>
                          <template v-slot:body>
                            <tr class="inner-product-bottles-row"
                                v-for="product in item.resultProducts.$values"
                                :key="product.id"
                            >
                              <td :style="item.resultProducts.$values.length > 1 ? '': 'height: 111px'" style="width: 89px">
                                <span class="font-weight-bold">{{product.number}}</span>
                              </td>
                              <td :style="item.resultProducts.$values.length > 1 ? '': 'height: 111px'" style="width: 37px">
                                <span class="font-weight-bold">{{product.doses}}</span>
                              </td>
                              <td style="padding: 0 5px;width: 100px" :style="item.resultProducts.$values.length > 1 ? '': 'height: 111px'">
                                <span class="font-weight-bold">${{product.price.toFixed(2)}}</span>
                              </td>
                              <td :style="item.resultProducts.$values.length > 1 ? '': 'height: 111px'"
                                  style="width: 49px" :class="{ 'adding-in-process': isStartCreateNewSupProduct === product.supplementProductId }">
                                <div class="d-flex align-center justify-center">
                                  <span class="font-weight-bold">{{product.quantity}}</span>
                                  <div class="d-flex flex-column">
                                    <v-icon :class="{ 'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status) }" @click="updateQuantityBottles(1, product, item.id)">mdi-chevron-up</v-icon>
                                    <v-icon :class="{ 'disabled': ['InProtocol', 'Completed', 'Closed', 'ProtocolEnding'].includes(visit.status) }" v-show="product.quantity > 1" @click="updateQuantityBottles(-1, product, item.id)">mdi-chevron-down</v-icon>
                                  </div>
                                </div>
                              </td>
                              <td style="padding: 0 5px;" :style="item.resultProducts.$values.length > 1 ? '': 'height: 111px'">
                                <div class="remove-supplement-product">
                                  <span class="font-weight-bold">${{product.amount.toFixed(2)}}</span>
                                  <v-icon v-if="item.resultProducts.$values.length > 1" @click="deleteSupplementProduct(item.id, product.id)">mdi-close</v-icon>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </Table>
                      </td>
                    </tr>
                  </template>
                </Table>
              </v-card>
            </td>
          </template>
        </template>
      </template>
    </Table>

    <Table
      class="table-total-cost"
      :headers="headers"
      hideDefaultFooter
      >

      <template v-slot:body>
        <tr class="custom-result-table__no-dynamic">
          <template v-for="(item, i) in headers.filter(el => !['actions'].includes(el.value))">
            <td :key="i" :my-attr="item.value" class="total-row" :style="{'width': runFunc('computed' + item.value + 'Width') + 'px'}"><!--v-show="item.type === 'Number'"-->
              <span class="total" v-if="item.value === 'supplementName'">Total:</span>
              <span v-if="item.value === 'daysSupply'">
              {{results.record[item.value] !== 0 ? results.record[item.value] : ''}}
            </span>
              <span v-if="item.value === 'totalCost'">
              {{results.record['totalPrice'] !== 0 ? '$' + results.record['totalPrice'].toFixed(2) : ''}}
            </span>
              <span v-if="item.value === 'daysPerWeek'"></span>
              <span v-if="item.value === 'patientNotes'"></span>
              <span v-if="item.value === 'totalScore'"></span>
              <span v-else>
              {{results.record['total'+_.upperFirst(item.value)] !== 0 ? results.record['total'+_.upperFirst(item.value)] : ''}}
            </span>
            </td>
          </template>
        </tr>
      </template>
    </Table>
    <add-result :orderMethod="orderMethod" v-if="dialogs.editResult.isOpen || dialogs.addResult.isOpen" />
    <confirm v-if="dialogs.confirm.isOpen" @close="updateAnything" />
    <edit-protocol-dialog v-if="dialogs.addProtocolDialog.isOpen || dialogs.editProtocolDialog.isOpen"/>
    <notes-dialog v-if="dialogs.notesDialog.isOpen" @showPopup="showPopup" />
    <modal-crg-notes v-if="dialogs.modalCrgNotes.isOpen"></modal-crg-notes>
    <div class="custom-alert">
      <v-alert
        color="#7ac1fb"
        dismissible
        type="info"
        v-model="alertIsOpen"
      >
        <span style="font-size: 14px;">{{popupMessage}}</span>
      </v-alert>
    </div>
    <div v-if="loading" class="loading d-flex justify-center px-2 py-2 align-center">
      <v-progress-circular
        indeterminate
        color="#008C89"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import notesSidebar from '@/components/layouts/notesSidebar.vue';
import Table from '@/components/elements/Table'
import checkbox from '@/components/elements/checkbox'
import addResult from '@/components/layouts/dialogs/add-result'
import confirm from '@/components/layouts/dialogs/confirm-dialog'
import actions from '@/components/layouts/actions'
import DosageControl from '@/components/elements/dosage-control'
import Number from '@/mixins/Number'
import NotesDialog from '@/components/layouts/dialogs/notes-dialog'
import EditProtocolDialog from '@/components/layouts/dialogs/edit-protocol-dialog'
import Image from '@/mixins/Image'
import ModalCrgNotes from '@/components/layouts/dialogs/modal-crg-notes'
import { trackEvent } from '@/utils/analytics'

const IS_CUSTOM_WIDTH = [
  'dosageUponArising',
  'dosageBreakfast',
  'dosage10am',
  'dosageLunch',
  'dosage3pm',
  'dosageDinner',
  'dosage7pm',
  'dosageBeforeSleep',
  'daysPerWeek',
  'patientNotes',
  'totalScore',
  'daysSupply',
  'bottles',
  'totalCost',
  'actions'
]

export default {
  name: 'results',
  props: {
    orderMethod: {
      type: Object
    },
    // calcMethod: {
    //   type: Object
    // },
    isUpdateResults: {
      type: Boolean,
      default: false
    },
    isUpdateDaysSupply: {
      type: Boolean,
      default: false
    },
    isUpdateVisit: {
      type: Boolean,
      default: false
    }
  },
  mixins: [Number, Image],
  components: { ModalCrgNotes, EditProtocolDialog, NotesDialog, Table, checkbox, addResult, confirm, actions, DosageControl, notesSidebar }, // , Select, Input, SpinInput, Button,
  data: () => ({
    customTableWidth: null,
    supplementDosages: [
      {
        id: 1,
        active: false,
        value: 1,
        text: '1'
      },
      {
        id: 2,
        active: false,
        value: 2,
        text: '2'
      },
      {
        id: 3,
        active: true,
        value: 3,
        text: '3'
      },
      {
        id: 4,
        active: false,
        value: 4,
        text: '4'
      },
      {
        id: 5,
        active: false,
        value: 5,
        text: '5'
      },
      {
        id: 6,
        active: false,
        value: 0,
        text: 'x'
      }
    ],
    supplementDosagesDaysPerWeek: [
      {
        id: 1,
        active: false,
        value: 1,
        text: '1'
      },
      {
        id: 2,
        active: false,
        value: 2,
        text: '2'
      },
      {
        id: 3,
        active: true,
        value: 3,
        text: '3'
      },
      {
        id: 4,
        active: false,
        value: 4,
        text: '4'
      },
      {
        id: 5,
        active: false,
        value: 5,
        text: '5'
      },
      {
        id: 6,
        active: false,
        value: 6,
        text: '6'
      },
      {
        id: 7,
        active: false,
        value: 7,
        text: '7'
      }
    ],
    expandedRows: [],
    expandedRowsGroup: [],
    product: null,
    totalTableSupWidth: 0,
    dosageUponArisingWidth: 0,
    dosageBreakfastWidth: 0,
    dosage10amWidth: 0,
    dosageLunchWidth: 0,
    dosage3pmWidth: 0,
    dosageDinnerWidth: 0,
    dosage7pmWidth: 0,
    dosageBeforeSleepWidth: 0,
    daysPerWeekWidth: 0,
    patientNotesWidth: 0,
    totalScoreWidth: 0,
    daysSupplyWidth: 0,
    bottlesWidth: 0,
    totalCostWidth: 0,
    isStartCreateNewSupProduct: false,
    alertIsOpen: false,
    popupMessage: null,
    loading: true
  }),
  methods: {
    runFunc (name) {
      return this[name]
    },
    ...mapActions('results', ['getOldResults', 'getNotes', 'updateResult', 'updateSupplementProduct', 'createSupplementProduct', 'removeSupplementProduct']),
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    ...mapMutations('results', ['UPDATE_DATA', 'UPDATE_STORE_DATA']),
    handleResize () {
      this.customTableWidth = document.querySelector('#custom-table-for-width').clientWidth
    },
    handleCrgNotesClick(item) {
      trackEvent(this, 'supplement_info', 'Results', 'Supplement Info', {
        supplement: item.supplementName
      })

      this.TOGGLE_DIALOG({
        name: 'modalCrgNotes',
        isOpen: true,
        title: item.supplementName,
        data: item
      })
    },
    editResult (item) {
      trackEvent(this, 'edit_result', 'Results', 'Click Supplement Name or Edit')
      if (item.params) {
        this.TOGGLE_DIALOG({ id: item.data.id, data: item.data, name: 'editResult', isOpen: true, title: `Edit supplement: ${item.data.supplementName}` })
      } else {
        this.TOGGLE_DIALOG({ id: item.id, data: item, name: 'editResult', isOpen: true, title: `Edit supplement: ${item.supplementName}` })
      }
    },
    async deleteResult (item) {
      await this.TOGGLE_DIALOG({
        id: item.data.id,
        name: 'confirm',
        isOpen: true,
        action: 'results/deleteResult',
        callback: (async () =>  {
          const result = await this.getOldResults({ id: this.$route.params.id, orderMethod: this.orderMethod.code })

          await this.$store.dispatch('visits/updateTotalSelectedResultSupplements', { totalSelectedResultSupplements: result.data.record.totalSelectedResultSupplements })
          this.getNotes(this.$route.params.id)
        }),
        description: 'Are you sure you want to delete the supplement?',
        title: 'Confirm deleting the Supplement'
      })
    },
    warningNotes (item) {
      this.TOGGLE_DIALOG({ name: 'notesDialog', title: 'Special Notes', isOpen: true, data: item }) // action: 'ResultSupplements/ClinicianNotes'
    },
    updateAnything() {
      this.getNotes(this.$route.params.id)
    },
    showPopup ({ res, supplementName }) {
      this.alertIsOpen = true
      this.popupMessage = `Notes for ${supplementName} was updated successfully`
      this.TOGGLE_DIALOG({ name: 'notesDialog', isOpen: false })
      const self = this
      setTimeout(function () {
        self.alertIsOpen = false
      }, 1300)
    },
    async updateSupplementUse (item, val) {
      const result = await this.updateResult({ id: item.id, form: { ...item, selected: val } })
      await this.$store.dispatch('visits/updateTotalSelectedResultSupplements', { totalSelectedResultSupplements: result.record.totalSelectedResultSupplements })
      this.getNotes(this.$route.params.id)
    },
    async updateSupplementDosage ({ data, keyProp }) {
      const result = await this.updateResult(data)
    },
    updateDataStore (result, key) {
      const payload = {
        dailyPrice: result.record.dailyPrice,
        daysSupply: result.record.daysSupply,
        monthlyPrice: result.record.monthlyPrice,
        totalBottles: result.record.totalBottles,
        totalDosage: result.record.totalDosage,
        totalDosage10am: result.record.totalDosage10am,
        totalDosage3pm: result.record.totalDosage3pm,
        totalDosage7pm: result.record.totalDosage7pm,
        totalDosageBeforeSleep: result.record.totalDosageBeforeSleep,
        totalDosageBreakfast: result.record.totalDosageBreakfast,
        totalDosageDinner: result.record.totalDosageDinner,
        totalDosageLunch: result.record.totalDosageLunch,
        totalDosageUponArising: result.record.totalDosageUponArising,
        totalPrice: result.record.totalPrice,
        weeklyPrice: result.record.weeklyPrice
      }
      this.UPDATE_DATA(payload)

      this.items.map(item => {
        if (item.id === result.record.resultSupplements.$values[0].id) {
          return Object.assign(item, { [key]: result.record.resultSupplements.$values[0][key] })
        }
      })
    },
    runAction (val) {
      val.params.action(val)
    },
    toggleRowGroup(key) {
      const index = this.expandedRowsGroup.indexOf(key)

      if (index !== undefined) {
        if (index > -1) {
          this.expandedRowsGroup.splice(index, 1)
          this.expandedRows = []
        } else {
          this.expandedRowsGroup.push(key)
        }
      }
    },
    toggleRow (id) {
      const index = this.expandedRows.indexOf(id)
      if (index > -1) {
        this.expandedRows.splice(index, 1)
      } else {
        trackEvent(this, 'supplement_details', 'Results', 'Open Dropdown to View Supplement Details')

        this.expandedRows = []
        this.expandedRows.push(id)
      }
    },
    async createNewSupplementProduct (resultSupplementId, data) {
      this.isStartCreateNewSupProduct = data.id
      const bottle = document.getElementById(`bottle-${data.id}`)
      const vitamin = bottle.querySelector('.vitamins')
      if (!vitamin.classList.contains('active-animation')) {
        const obj = {
          resultSupplementId: resultSupplementId,
          supplementProductId: data.id,
          numberOfBottles: 1, // data.quantity,
          price: data.listPrice
        }

        const res = await this.createSupplementProduct(obj)
        this.UPDATE_STORE_DATA(res)

        await this.getOldResults({ id: this.$route.params.id, orderMethod: this.orderMethod.code })
        this.getNotes(this.$route.params.id)

        vitamin.classList.add('active-animation')
        const self = this
        setTimeout(function () {
          vitamin.classList.remove('active-animation')
          self.isStartCreateNewSupProduct = false
        }, 1000)
      }
    },
    async deleteSupplementProduct (resultSupplementId, supplementProductId) {
      const res = await this.removeSupplementProduct({ resultSupplementId, supplementProductId })
      await this.getOldResults({ id: this.$route.params.id, orderMethod: this.orderMethod.code })
      this.getNotes(this.$route.params.id)
      this.UPDATE_STORE_DATA(res)
    },
    async updateQuantityBottles (val, product, resultSupplementId) {
      const res = product.quantity + val
      if (res >= 1) {
        const response = await this.updateSupplementProduct({ resultSupplementId, supplementProductId: product.id, numberOfBottles: res })
        await this.getOldResults({ id: this.$route.params.id, orderMethod: this.orderMethod.code })
        this.getNotes(this.$route.params.id)
        this.UPDATE_STORE_DATA(response)
      }
    },
    getQuantityBySupplementProductId (resultProducts, productId) {
      const product = resultProducts.find(item => item.supplementProductId === productId)
      return product && product.quantity ? product.quantity : '0'
    },
    getSelectedItems(array) {
      let count = 0
      array.map(item => {
        if (item.selected) {
          count++
        }
      })
      return count
    }
  },

  async mounted () {
    this.loading = true
    const { id } = this.$route.params
    const res = await this.getOldResults({ id, orderMethod: null, calcMethod: null })
    if (res) {
      const obj = this.patientOrderMethods.find(item => item.code === this.results.record.orderMethodCode)

      this.$emit('updateOrderMethod', obj)
      if (res.data.record.surveyScore >= 0) {
        this.$emit('updateSurveySummary', res.data.record.surveyScore)
      }
      this.loading = false
      this.getNotes(id)
      this.expandedRowsGroup = this.items.map(itemGroup => itemGroup.name)
    }
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  updated: function () {
    this.$nextTick(function () {
      const totalTableSupWidth = this?.$refs?.['totalTableSupWidth']?.[0]?.clientWidth

      if(totalTableSupWidth) {
        this?.$refs?.['total-cell']

        this.totalTableSupWidth = totalTableSupWidth;
      }
    })
  },

  computed: {
    ...mapState('results', {
      headers (state) {
        const headers = Object.assign([], state?.results?.headers?.$values)
        headers.push({ icon: 'mdi-cog', value: 'actions', isIcon: true, sortable: false })
        return headers?.map(el => ({
          ...this._.omit(el, ['skip', '$id', 'width']),
          text: el.value !== 'actions' ? el.text.toUpperCase().replace(/ /gi, '<br/>') : el.text,
          isReplacingSpace: el.value !== 'actions' ? 1 : 0,
          width: (IS_CUSTOM_WIDTH.includes(el.value)) ? 40 + 'px' : 'auto',
        })).filter(el => {
          return el.text !== 'USE'
        })
      },

      items (state) {
        const updatedValues = state?.results?.record?.resultSupplementGroups?.$values.map(group => {
          return {
            ...group,
            resultSupplements: {
              $id: group.$id,
              $values: group.resultSupplements.$values.map(item => {
                return Object.assign(item, { supplementWidth: '200px' }) // temporary code
              })
            }
          }
        })
        const items = Object.assign([], updatedValues)
        return items
      }
    }),

    ...mapState({
      patientOrderMethods: state => state.settings.patients.patientOrderMethods.$values.map(item => {
        return {
          ...item,
          text: item.name,
          value: item.code,
          id: item.$id
        }
      }),
      visit: state => state.visits?.visit
    }),
    actions () {
      return [
        { icon: 'mdi-pencil', color: 'grey', name: 'Edit', action: this.editResult },
        { icon: 'mdi-trash-can-outline', color: 'grey', name: 'Delete', action: this.deleteResult }
      ]
    },
    dialogs () {
      return this.$store.state.dialogs
    },
    results () {
      return this.$store.state?.results?.results
    },
    drawerState () {
      return this.$store.state.drawerState
    },
  },
  watch: {
    items (val) {
      if (val && val.length > 0) {
        this.$nextTick(() => {
          this.totalTableSupWidth = document.querySelector('.totalTableSupWidth').getBoundingClientRect().width
          this.dosageUponArisingWidth = document.querySelector('.dosageUponArisingWidth').getBoundingClientRect().width
          this.dosageBreakfastWidth = document.querySelector('.dosageBreakfastWidth').getBoundingClientRect().width
          this.dosage10amWidth = document.querySelector('.dosage10amWidth').getBoundingClientRect().width
          this.dosageLunchWidth = document.querySelector('.dosageLunchWidth').getBoundingClientRect().width
          this.dosage3pmWidth = document.querySelector('.dosage3pmWidth').getBoundingClientRect().width
          this.dosageDinnerWidth = document.querySelector('.dosageDinnerWidth').getBoundingClientRect().width
          this.dosage7pmWidth = document.querySelector('.dosage7pmWidth').getBoundingClientRect().width
          this.dosageBeforeSleepWidth = document.querySelector('.dosageBeforeSleepWidth').getBoundingClientRect().width
          this.daysPerWeekWidth = document.querySelector('.daysPerWeekWidth').getBoundingClientRect().width
          this.patientNotesWidth = document.querySelector('.patientNotesWidth').getBoundingClientRect().width
          this.totalScoreWidth = document.querySelector('.totalScoreWidth').getBoundingClientRect().width
          this.daysSupplyWidth = document.querySelector('.daysSupplyWidth').getBoundingClientRect().width
          this.bottlesWidth = document.querySelector('.bottlesWidth').getBoundingClientRect().width
          this.totalCostWidth = document.querySelector('.totalCostWidth').getBoundingClientRect().width
        })

        this.expandedRowsGroup = this.items.map(itemGroup => itemGroup.name)
      }
    },

    async 'isUpdateResults' (val) {
      if (val) {
        const { id } = this.$route.params
        const res = await this.getOldResults({ id, orderMethod: null })
        if (res) {
          const obj = this.patientOrderMethods.find(item => item.code === this.results.record.orderMethodCode)
          this.getNotes(this.$route.params.id)
          this.$emit('updateOrderMethod', obj)
        }
        this.$emit('updateIsUpdateResults', false)
      }
    },
    async 'isUpdateDaysSupply' (val) {
      if (val) {
        const { id } = this.$route.params
        const res = await this.getOldResults({ id, orderMethod: this.orderMethod.code, calcMethod: null })
        if (res) {
          this.getNotes(id)
          this.$emit('updateIsUpdateDaysSupply', false)
        }
      }
    },
    async 'isUpdateVisit' (val) {
      if (val) {
        const { id } = this.$route.params
        const res = await this.getOldResults({ id, orderMethod: this.orderMethod.code, calcMethod: null })
        if (res) {
          this.getNotes(id)
          this.$emit('updateIsUpdateVisit', false)
        }
      }
    },
    drawerState (val) {
      setTimeout(() => {
        this.totalTableSupWidth = document.querySelector('.totalTableSupWidth').getBoundingClientRect().width
        this.dosageUponArisingWidth = document.querySelector('.dosageUponArisingWidth').getBoundingClientRect().width
        this.dosageBreakfastWidth = document.querySelector('.dosageBreakfastWidth').getBoundingClientRect().width
        this.dosage10amWidth = document.querySelector('.dosage10amWidth').getBoundingClientRect().width
        this.dosageLunchWidth = document.querySelector('.dosageLunchWidth').getBoundingClientRect().width
        this.dosage3pmWidth = document.querySelector('.dosage3pmWidth').getBoundingClientRect().width
        this.dosageDinnerWidth = document.querySelector('.dosageDinnerWidth').getBoundingClientRect().width
        this.dosage7pmWidth = document.querySelector('.dosage7pmWidth').getBoundingClientRect().width
        this.dosageBeforeSleepWidth = document.querySelector('.dosageBeforeSleepWidth').getBoundingClientRect().width
        this.daysPerWeekWidth = document.querySelector('.daysPerWeekWidth').getBoundingClientRect().width
        this.patientNotesWidth = document.querySelector('.patientNotesWidth').getBoundingClientRect().width
        this.totalScoreWidth = document.querySelector('.totalScoreWidth').getBoundingClientRect().width
        this.daysSupplyWidth = document.querySelector('.daysSupplyWidth').getBoundingClientRect().width
        this.bottlesWidth = document.querySelector('.bottlesWidth').getBoundingClientRect().width
        this.totalCostWidth = document.querySelector('.totalCostWidth').getBoundingClientRect().width
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
  .result {
    min-height: 100px;

    .disabled {
      pointer-events: none;
    }

    .table#custom-table-for-width {
      ::v-deep .v-data-table-header {
        tr {
          th {
            border-bottom: none !important;

            &:not(:last-child) {
              border-right: 1px solid #E5ECF2;
            }
          }
        }
      }

      .cell-style {
        color: #1A202C;
        font-size: 15px;
        font-weight: 600;
      }
      .row-group {
        background-color: #F7FAFC;
        height: 50px;
        cursor: pointer;

        &:hover {
          background-color: #e4eef4;
        }

        .group-values {
          font-weight: 600;
          font-size: 14px;
          color: #A6B7D4;

          &__title {
            color: #718096;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
          }
        }
      }
      .custom-result-table {
        table-layout : fixed;

        &__dynamic {
          td {
            padding: 0 4px;
            border-bottom: 1px solid #CBD5E0;
            height: 50px;

            &:first-child {
              padding-left: 20px;
            }

            &:not(:last-child) {
              border-right: 1px solid #E5ECF2;
            }

            .width100 {
              width: 100% !important;
            }
            .height100 {
              height: 100% !important;
            }
            div[aria-expanded=true] {
              background-color: #c3e5c399;
            }
            div[aria-expanded=false] {
              background-color: unset;
            }

            .checkbox {
              ::v-deep .v-input .v-icon {
                color: #C9CED6;
              }
            }
          }
          .totalTableSupWidth {
            .disabled {
              pointer-events: none;
            }
          }
        }
        &__dynamic:last-child {
          td {
            border-bottom: unset;
          }
        }
        &__dynamic.expand-row {
          background-color: #e0fff4;
          .table {
            padding: 0px!important;
          }
        }
        &__dynamic.expand-row-group {
          height: 40px;
          background-color: #F7FAFC;
          cursor: pointer;
          .table {
            padding: 0px!important;
          }
        }
        &__dynamic.expand-row-group:hover {
          background-color: #e4eef4;
        }
        &__no-dynamic {
          border-bottom:thin solid #0000001f;
          td {
            height: 52px;
            border-right: thin solid transparent;
          }
          td:last-child {
            border-right: unset;
          }
        }
      }
    }

    .table {
      overflow-y: scroll;
      max-height: 70vh;

      ::v-deep .v-data-table {
        .v-data-table-header {
          tr {
            th {
              & > div:not(.search-filter) {
                width: 100%!important;
                justify-content: center!important;
              }
              div.v-input__slot {
                width: 100%!important;
              }
              div.search-filter {
                width: 100%;

                .filter-activator {
                  margin: auto;
                }
              }
              div#filter-activator-2 {
                width: 130px!important;
                margin-left: 5px!important;
              }
              .v-input__append-inner {
                width: unset!important;
              }
            }
          }
        }
        tr {
          &.highlighted-row {
            background-color: #F7FAFC;
          }
          &:not(.grouped-table) {
            td {
              .input {
                width: 90px;
                .v-input {
                  .v-input__control {
                    .v-text-field__details {
                      display: none!important;
                    }
                  }
                }
              }
            }
          }
        }

        .v-data-table-header tr th .v-input__prepend-inner {
          margin-top: 9px!important;
          width: fit-content!important;
        }
      }
      ::v-deep .v-menu {
        .v-menu__content {
          z-index: 100!important;
        }
      }
    }
    .table.total-table {
      background: #ededed; // #FAFAFB
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      padding-left: 16px!important;
      padding-right: 16px!important;
      padding-top: 0!important;
    }

    .table.table-total-cost {
      border-top: 1px solid #EDF2F7;
      font-size: 14px;
      font-weight: 600;
      background-color: #F7FAFC;
      overflow-y: hidden;
      box-shadow:
        0px 4px 20px -2px #32324714,
        0px 0px 1px 0px #0C1A4B1A;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;

      .total {
        padding-left: 32px;
        width: 100%;
        display: flex;
        color: #718096;
        font-size: 14px;
        font-weight: 600 !important;
      }

      ::v-deep .v-data-table {
        padding-right: 14px;

        tr {
          td {
            color: #425466;
            height: 60px;
            padding: 0 6px;
          }
        }
        .v-data-table-header tr th:first-child {
          max-width: 396px!important;
          min-width: 396px!important;
        }
        .v-data-table-header {
          visibility: collapse!important;
        }
      }
    }

    .v-icon {
      cursor: pointer;
    }
    .table {
      ::v-deep .v-data-table .v-data-table__wrapper .v-data-table-header th {
        padding: 0 4px!important;
      }
      ::v-deep .v-data-table {
        background: transparent!important;
      }
    }
    .custom-alert {
      max-width: 300px;
      position: fixed;
      top: 10px;
      right: 20px;
      z-index: 100;
    }
    .is-manual-entered {
      background-color: #E4FFD5;
    }
    .is-default {
      background-color: #E3F7EA;
    }
    .tooltips {
      div {
        display: flex;
      }
      div:hover {
        background: unset!important;
      }
    }
    .loading {
      height: 100%;
      min-height: 100px;
      position: absolute;
      width: 100%;
      top: 0;
      background: rgb(213 213 213 / 50%);
      border-radius: 16px;
    }
  }
  .circle-dot {
    height: 8px;
    width: 8px;
    background-color: grey;
    border-radius: 50%;
    display: inline-block;
    margin: 0 2px;
  }
  .circle-dot.light-green {
    background-color: #75DC98!important;
  }
  .circle-dot.light-orange {
    background-color: #F7936F!important;
  }
  .circle-dot:first-child {
    margin-left: 10px;
  }
  .circle-dot:last-child {
    margin: 0 0 0 2px;
  }
  .circle-dot.dark-green {
    background-color: #28605A!important;
  }
  .circle-dot.green {
    background-color: #499D66!important;
  }
  .circle-dot.dark-orange {
    background-color: #F16063!important;
  }
  .circle-dot.light-blue {
    background-color: #00E0FF!important;
  }
  .circle-dot.blue {
    background-color: #537CFF!important;
  }
  .total-row {
    text-align: center;
  }
  .supplement-width {
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
    word-wrap: break-word;
  }
  ::v-deep .v-tooltip__content {
    padding: 3px 3px;
  }
  .dinner-tooltip {
    padding: 3px!important;
  }
  .days-per-week {
    ::v-deep .v-text-field__details {
      display: none !important;
    }
  }

  .product-supplement {
    padding: 10px 10px;
    background: #EDF2F7;
    border-bottom: unset;
    ::v-deep .v-card {
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)!important;
      .table {
        padding: 0px!important;
        .v-data-table .v-data-table__wrapper {
          table {
            .sub-row {
              .table {
                padding: 0!important;
              }
              th {
                padding-top: 15px;
                padding-bottom: 15px;
              }
              tr:last-child {
                td {
                  border-bottom: unset;
                }
              }
              td {
                //border-bottom: unset;
              }
            }
          }
        }
      }
    }
    .product-bottles {
      .main-row {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        column-gap: 1rem;
        row-gap: 1rem;
        padding: 5px 10px;
        align-items: center;
        .bottle {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          width: 139px;
          align-items: center;
          column-gap: 0.4rem;
          cursor: pointer;
          background: #008c8933;
          border-radius: 10px;
          padding: 8px 3px;
          justify-content: flex-start;
          .btn-bottle {
            width: 50px;
            //height: 50px;
            //background: #56c8472e;
            //border-radius: 10px;
            .v-icon {
              margin-top: 10px;
              color: #008C89;
            }
            .v-icon.discontinued {
              margin-top: 10px;
              color: #A0AEC0;
            }
            ::v-deep .v-badge {
              margin-top: 10px;
            }
          }
          .bottle-info {
            p {
              margin-top: 0;
              margin-right: 0;
              margin-bottom: 0;
              margin-left: 8px;
            }
            font-weight: bold;
            color: #008C89;
          }
          .bottle-info.discontinued {
            color: #A0AEC0;
          }
          .bottle-plus {
            ::v-deep .v-icon {
              color: #008C89;
            }
          }
          .bottle-plus.discontinued {
            ::v-deep .v-icon {
              color: #A0AEC0;
            }
          }
          .bottle-cost {
            font-weight: bold;
            color: #008C89;
            font-size: 14px;
            margin-left: 8px;
          }
          .bottle-cost.discontinued {
            color: #A0AEC0;
          }
        }
        .bottle.discontinued {
          background: #CBD5E0;
          color: #A0AEC0;
        }
      }
    }
    .inner-product-bottles-row {}
    .remove-supplement-product {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
    }
  }
  .sub-row {
    &__title {
      font-size: 10px;
      font-weight: 600;
      color: #8492A6;
      white-space: nowrap;
      text-transform: uppercase;
    }
    tr:last-child {
      td {
        border-bottom: unset;
      }
    }
    td {
      border-bottom: 1px solid #0000001f;
      text-align: center;
    }
  }
  .adding-in-process {
    background-color: #e0fff4;
  }
  .vitamins {
    width: 30px;
    height: 30px;
    position: absolute;
    visibility: hidden;
    background-image: url("../../../assets/icons/vitamins.png");
    background-size: 25px;
    bottom: 20px;
  }
  .vitamins.active-animation {
    visibility: visible;
    animation: moveXandSpin 1s none;
  }
  @keyframes moveXandSpin {
    from {
      transform: translateX(0px) rotate(0);
    }
    to {
      transform: translateX(570px) rotate(720deg);
    }
  }
  .result {
    .table.dynamic-width {
      ::v-deep {
        .actions {
          .v-menu {
            [role="menu"] {
              left: 90%!important;
            }
          }
        }
      }
    }
  }
  .red-line {
    border-left: 3px solid #FCDFE0;
  }
  .blue-line {
    border-left: 3px solid #D0DCFF80;
  }

.rotate-180 {
  transform: rotate(180deg);
}
</style>
